import $  from 'jquery';

export const showSearch = () => {
    $('.js-mob-search').on('click', function () {
        $('.js-modal-search').toggleClass('active');
    })
}
